// extracted by mini-css-extract-plugin
export default {"container":"NoTenant_container__RynB6","contents":"NoTenant_contents__iIn7g","alert_icon":"NoTenant_alert_icon__Kp2mP","text":"NoTenant_text__wdpcT"};